module.exports = __webpack_public_path__ + "img/zj-icon.dc653e3c.png";